module.exports = __webpack_public_path__ + "img/banner-1-m.b0de22ed.jpg";